import { render, staticRenderFns } from "./cus-header.vue?vue&type=template&id=106fd5f4&scoped=true"
import script from "./cus-header.vue?vue&type=script&lang=js"
export * from "./cus-header.vue?vue&type=script&lang=js"
import style0 from "./cus-header.vue?vue&type=style&index=0&id=106fd5f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "106fd5f4",
  null
  
)

export default component.exports